<template>
  <Modal v-if="display" @hideModal="toggleModal" :wide="true">
    <h1 class="font-bold text-lg">Enter your code</h1>
    <ul v-if="errors.length > 0">
      <li v-for="(error, index) in errors" :key="index" class="text-red-600">{{ error }}</li>
    </ul>
    <form class="address-form bg-white w-11/12 justify-center mx-auto mt-6">
      <div class="flex items-center justify-between relative round-form">
        <input
          v-model="ndcCode"
          class="
            appearance-none
            bg-transparent
            w-8/12
            mt-0
            mb-0
            mr-3
            py-2
            px-2
            leading-tight
            focus:outline-none
            rounded-3xl
          "
          type="text"
          placeholder="What code did you receive?"
          aria-label="Code"
          id="ndcCode"
        />
        <button
          class="
            flex-shrink-0
            text-sm
            font-bold
            button
            text-white
            py-3
            px-1
            rounded-3xl
            w-3/12
            coupon-button
          "
          type="button"
          :disabled="!ndcCode || lookupProcessing"
          @click.stop.prevent="codeUpdate"
        >
          Submit
        </button>
      </div>
    </form>
  </Modal>
</template>

<script setup>
import { ref } from 'vue';
import { useNuxtApp } from '#app';

// Reactive state
const display = ref(false);
const errors = ref([]);
const lookupProcessing = ref(false);
const ndcCode = ref('');

const nuxtApp = useNuxtApp();
const { $sg, $ndc } = nuxtApp;

// Methods
const show = () => {
  display.value = true;
  errors.value = [];
};

const hide = () => {
  display.value = false;
};

const toggleModal = () => {
  display.value = !display.value;
};

defineExpose({show, hide, toggleModal});

const codeUpdate = async () => {
  try {
    lookupProcessing.value = true;
    errors.value = [];

    const ndcLookupStatus = await $sg.enterNdcCode(ndcCode.value, nuxtApp);

    if (!ndcLookupStatus) {
      errors.value.push("Failed to validate this code.");
      return;
    }

    $ndc.addTouchPoint(ndcCode.value, false);
  } catch (err) {
    console.error(err);
    errors.value.push("Something went wrong, please try again later.");
  } finally {
    lookupProcessing.value = false;
  }
};
</script>


<style scoped>
input[type="text"] {
  border: 4px solid #fff;
  margin-top: 0;
  margin-bottom: 0;
  border-radius: 100px;
}

::placeholder {
  color: #517185;
}

button[disabled=disabled] {
  background-color: grey;
  pointer-events: none;
}

.coupon-button {
  width: 25%;
  min-width: 100px;
}
</style>